import { render, staticRenderFns } from "./VolunteerTeamOfferDetails.vue?vue&type=template&id=570c35d1&scoped=true"
import script from "./VolunteerTeamOfferDetails.vue?vue&type=script&lang=js"
export * from "./VolunteerTeamOfferDetails.vue?vue&type=script&lang=js"
import style0 from "./VolunteerTeamOfferDetails.vue?vue&type=style&index=0&id=570c35d1&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./VolunteerTeamOfferDetails.vue?vue&type=style&index=1&id=570c35d1&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c35d1",
  null
  
)

export default component.exports